import shuffle from 'lodash/shuffle';
import isEmpty from 'lodash/isEmpty';
import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { getLabels } from '../../QuickSearchActions';

import './RxSearchLabel.scss';

export const rotatingInterval = 4000;
export const transitionClassName = 'rotating-label--transition';
export const transitionTimeout = 300;

function RxSearchLabel({ onSuffixClick }) {
  const ref = useRef();
  const [currentLabel, setCurrentLabel] = useState(0);
  const [labelsText, setLabelsText] = useState([]);

  const setCurrentLabelAnimated = (nextLabel) => {
    ref.current.classList.add(transitionClassName);
    setTimeout(() => {
      if (!ref.current) return;
      ref.current.classList.remove(transitionClassName);
      setCurrentLabel(nextLabel);
    }, transitionTimeout);
  };

  useEffect(() => {
    getLabels()
      .then((data) => {
        setLabelsText(shuffle(data));
      })
      .catch(Logger.error);
  }, []);

  useEffect(() => {
    let interval;

    if (!isEmpty(labelsText)) {
      interval = setInterval(() => {
        setCurrentLabelAnimated((_value) => (_value >= labelsText.length - 1 ? 0 : _value + 1));
      }, rotatingInterval);
    }

    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [labelsText]);

  const labelText = labelsText[currentLabel];

  return (
    <span ref={ref} className="rotating-label">
      {!!labelText && (
        <span>
          <span className="prefix">{labelText.prefix}</span>
          {}
          <a
            data-e2e="search-label-suffix-link"
            href="null"
            tabIndex="0"
            className="sufix-link"
            onClick={(e) => {
              e.preventDefault();
              onSuffixClick(labelText.suffix);
            }}>
            {labelText.suffix}
          </a>
        </span>
      )}
    </span>
  );
}

RxSearchLabel.defaultProps = {
  onSuffixClick: () => {},
};

RxSearchLabel.propTypes = {
  onSuffixClick: PropTypes.func,
};

export default RxSearchLabel;
